import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import template from 'url-template';

import { find, findIndex, get, has, isEmpty, cloneDeep } from 'lodash';

import { orderBy, filterBy } from '@progress/kendo-data-query';
import Tooltip from '@material-ui/core/Tooltip';
import { Grid, getSelectedState, GridColumn as Column } from '@progress/kendo-react-grid';
import { getter } from '@progress/kendo-react-common';

import EsmsPage from '../../components/EsmsPage';
import EditProfileForm from '../../components/EditProfileForm';
import { getObjectType } from '../../helpers/bacnetObjectTypeConversion';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import BacnetDataTypeSelect from '../../components/InventoryTable/BacnetDataTypeSelect';
import BacnetSampleIntervalSelect from '../../components/InventoryTable/BacnetSampleIntervalSelect';

import PendingActionsModal from '../Modals/PendingActionsModal';
import ProfileObjectModificationModal from '../Modals/ProfileObjectModificationModal';
import ProfileObjectModificationResultModal from '../Modals/ProfileObjectModificationResultModal';

import * as ApplicationMessageActions from '../../actions/applicationMessageActions';
import * as CoreActions from '../../actions/coreActions';
import * as DeviceActions from '../../actions/deviceActions';
import * as InventoryActions from '../../actions/inventoryActions';
import * as ProfileActions from '../../actions/profileActions';
import * as ProfileObjectActions from '../../actions/profileObjectActions';
import { createBulkProfileObject } from '../../actions/iotHubActions';
import { kendoGridInlineStyling } from '../../helpers/kendoGridInlineStyleHelper';
import classes from './BacnetProfileCreatePage.module.css';

const AgentUrl = template.parse('/iothub/basagents/manage{?company,basAgent}');
const AgentsUrl = template.parse('/iothub/basagents{?company}');
const InventoryUrl = template.parse('/iothub/basagents/manage/inventory/bacnet{?basAgent,company}');

const idGetter = getter('id');

const initialDataState = {
    filter: [],
    sort:   [],
    take:   20,
    skip:   0
};
const InitialProfile = Object.freeze({
    basType:   null,
    deviceIds: [],
    name:      ''
});

const Types = {
    boolean: 'Boolean',
    float:   'Float',
    integer: 'Integer',
    text:    'Text'
};

class BacnetProfileCreatePage extends Component {
    state = {
        completedObjects:        0,
        dataErrors:              {},
        isSubmitting:            false,
        skip:                    0,
        dataState:               initialDataState,
        gridData:                [],
        filteredGridData:        [],
        tableSelectState:        {},
        objects:                 [],
        filteredObjects:         [],
        pendingActions:          {},
        pendingObjects:          0,
        profile:                 {},
        resultErrors:            [],
        showPendingActionsModal: false,
        tableColumns:            [],
        filterable:              false,
        filter:                  {}
    };

    componentDidMount() {
        const {
            selectedAgent,
            selectedDevice
        } = this.props;

        this.setProfile({
            name:      '',
            deviceIds: [],
            basType:   get(selectedAgent, 'driverConfiguration[0].basType', '').toLowerCase()
        });

        if (!isEmpty(selectedDevice)) {
            const objects = [...selectedDevice.items];

            objects.forEach((object, index) => {
                const convertedObjectType = getObjectType(object.ObjectType);

                object.sampleInterval = 15;
                object.displayObjectType = `${convertedObjectType} - ${object.ObjectInstance}`;
                object.useDescriptionAsName = object.Description !== undefined && object.Description !== '';
            });

            this.setState({
                objects
            });

            const data = [...objects];

            const initialData = data.splice(0, 20);

            this.setState({
                filteredObjects: data
            });

            this.setState({
                gridData: initialData
            });
        }
    }

    setProfile = (profile = {}) => {
        let newProfile;

        if (isEmpty(profile)) {
            newProfile = {...InitialProfile};
        } else {
            newProfile = {...profile};
        }

        this.setState({
            profile: newProfile
        });
    }

    objectSorter = (a, b) => {
        const valueA = a.ObjectName.toUpperCase();
        const valueB = b.ObjectName.toUpperCase();

        if (valueA < valueB) {
            return -1;
        }
        if (valueA > valueB) {
            return 1;
        }

        return 0;
    };

    preparePendingActions = () => {
        const { objects, tableSelectState } = this.state;

        const pendingActionData = {
            actionableData: {
                title: 'To be created',
                data:  []
            },
            nonActionableData: {
                title: 'Will not be created',
                data:  []
            }
        };

        let deviceIds = Object.keys(tableSelectState).filter((key) => tableSelectState[key]);

        deviceIds.forEach(deviceId => {
            const device = find(objects, item => item.id === deviceId);

            device.name = device.useDescriptionAsName ? get(device, 'Description', '') : get(device, 'ObjectName', '');

            if (device.dataType && has(Types, device.dataType)) {
                pendingActionData.actionableData.data.push(device);
            } else if (!device.dataType || !has(Types, device.dataType)) {
                const ignoredDevice = {
                    ...device,
                    reason: 'Data type not selected.',
                    action: 'Select a data type.'
                };

                pendingActionData.nonActionableData.data.push(ignoredDevice);
            }
        });

        this.setState({ pendingActions: pendingActionData });
    };

    handlePendingActionsModal = isOpen => {
        this.setState({ showPendingActionsModal: isOpen });
    }

    handleResultClose = () => {
        this.setState({
            completedObjects: 0,
            pendingObjects:   0,
            isSubmitting:     false,
            resultErrors:     []
        });
    }

    handleCancel = () => {
        const objects = [...this.state.objects];
        this.setProfile();

        objects.forEach((item) => {
            item.useDescriptionAsName = false;
            item.selected = false;
        });

        this.setState({
            objects,
            tableSelectState: {},
            resultErrors:     []
        });
    }

    handleChange = modifiedProfile => {
        this.setProfile(modifiedProfile);
    }

    handleCreate = () => {
        this.preparePendingActions();

        this.setState({ showPendingActionsModal: true });
    }

    handleSubmit = async () => {
        const {
            bacnetInventory,
            companyInfo,
            createBulkProfileObject,
            createProfile,
            selectedDevice,
            setBacnetInventory
        } = this.props;

        const { profile, pendingActions } = this.state;
        let newProfile;

        this.setState({ resultErrors: [] });

        this.props.setProgressBarLoading(true);

        if (!profile.id) {
            newProfile = await createProfile(
                companyInfo.companyId,
                profile
            );

            this.setProfile({
                ...profile,
                id: newProfile.id
            });
        }

        let profileId = get(profile, 'id') || get(newProfile, 'id', '');

        selectedDevice.profileName = profile.name;
        selectedDevice.profileId = profileId;
        selectedDevice.tableData.checked = false;

        const deviceIndex = findIndex(bacnetInventory, item => item.id === selectedDevice.id);
        bacnetInventory[deviceIndex] = {...selectedDevice};

        setBacnetInventory(bacnetInventory);

        const actionableDevices = get(pendingActions, 'actionableData.data', []);

        const profileObjects = [];
        actionableDevices.forEach(device => {
            const name = device.useDescriptionAsName ? get(device, 'Description', '') : get(device, 'ObjectName', '');
            profileObjects.push({
                changeOfValue:  device.sampleInterval === 0,
                dataType:       get(device, 'dataType', ''),
                name,
                objectId:       get(device, 'ObjectInstance', ''),
                objectType:     get(device, 'ObjectType', ''),
                propertyId:     get(device, 'PropertyID', ''),
                sampleInterval: get(device, 'sampleInterval', 15),
                arrayIndex:     get(device, 'ArrayIndex', '')
            });
        });

        if (!isEmpty(profileObjects)) {
            this.setState({ isSubmitting: true });
            await createBulkProfileObject(profileId, profileObjects, this.handleRedirectToInventory, this.handleSetIsSubmitting, this.handleSetRequestErrors, this.handleSetCompletedObjects, this.handleSetPendingObjects);
            this.props.setProgressBarLoading(false);
        } else {
            this.props.enqueueSnackbar(`Profile created successfully`, 'success');
            this.props.setProgressBarLoading(false);
            this.handleRedirectToInventory();
        }
    }

    handleSetPendingObjects = pendingObjects => {
        this.setState({
            pendingObjects
        });
    };

    handleSetCompletedObjects = completedObjects => {
        this.setState({
            completedObjects
        });
    };

    handleSetRequestErrors = resultErrors => {
        this.setState({
            resultErrors
        });
    };

    handleSetIsSubmitting = toggle => {
        this.setState({
            isSubmitting: toggle,
        });
    };

    handleRedirectToIotHub = () => {
        const { history } = this.props;

        history.push('/iothub' + history.location.search.search);
    }

    handleRedirectToAgents = () => {
        const { companyInfo, history } = this.props;

        history.push(AgentsUrl.expand({
            company: companyInfo.companyId
        }));
    }

    handleRedirectToAgent = () => {
        const { companyInfo, history, selectedAgent } = this.props;

        history.push(AgentUrl.expand({
            company:  companyInfo.companyId,
            basAgent: selectedAgent.id
        }));
    }

    handleRedirectToInventory = () => {
        const { companyInfo, history, selectedAgent } = this.props;

        history.push(InventoryUrl.expand({
            company:  companyInfo.companyId,
            basAgent: selectedAgent.id
        }));
    }

    handleSelectObjectFormChange = object => {
        const objects = [...this.state.objects];

        const objectIndex = findIndex(objects, item => item.id === object.id);

        objects[objectIndex] = {...object};

        this.setState({
            objects
        });
    }

    handleNameDescriptionSwap = () => {
        const deviceGuids = Object.keys(this.state.tableSelectState).filter(item => {
            return this.state.tableSelectState[item];
        });
        const objects = [...this.state.objects];

        deviceGuids.forEach(deviceGuid => {
            const targetDevice = objects.find(object => object.id === deviceGuid);

            targetDevice.useDescriptionAsName = !targetDevice.useDescriptionAsName;
        });

        this.setState({
            objects
        });
    }

    renderName = dataItem => {
        const rowData = dataItem.dataItem;

        let name, title, tooltipValue;
        let showCheckmark = false;

        name = get(rowData, dataItem.field === 'ObjectName' ? 'ObjectName' : 'Description');

        tooltipValue = get(rowData, dataItem.field === 'ObjectName' ? 'ObjectName' : 'Description');
        title = `${dataItem.field === 'ObjectName' ? 'ObjectName' : 'Object Description'}: ${tooltipValue === undefined || tooltipValue === '' ? 'Not Available' : tooltipValue}`;

        if (dataItem.field === 'ObjectName' && !rowData.useDescriptionAsName) {
            showCheckmark = true;
        }
        else if (dataItem.field === 'Description' && rowData.useDescriptionAsName) {
            showCheckmark = true;
        }

        return (
            <Tooltip
                title={title}
                placement="top"
                classes={{ tooltip: classes.Tooltip }}
            >
                <td style={{whiteSpace: 'nowrap'}}>{showCheckmark ? <span className="material-icons-outlined md-12" style={{paddingRight: '5px'}}>check</span> : null}{name}</td>
            </Tooltip>
        );
    }

    renderUseAsDescriptionCell = dataItem => {
        const rowData = dataItem.dataItem;

        if (rowData.useDescriptionAsName) {
            return (<td><span class="material-icons-outlined md-12">check</span></td>);
        }
        else 
        {
            return (<td>&nbsp;</td>);
        }
    };

    renderDataTypeCell = dataItem => {
        const rowData = dataItem.dataItem;
        return (
            <td>
                <BacnetDataTypeSelect
                    onChange={this.handleSelectObjectFormChange}
                    rowData={rowData}
                />
            </td>
        );
    }

    renderTrendIntervalCell = dataItem => {
        const rowData = dataItem.dataItem;
        return (
            <td>
                <BacnetSampleIntervalSelect
                    onChange={this.handleSelectObjectFormChange}
                    rowData={rowData}
                />
            </td>
        );
    }

    renderObjectTypeCell = dataItem => {
        const rowData = dataItem.dataItem;
        return (
            <td>
                {rowData.displayObjectType}
            </td>
        );
    }

    dataStateChange = e => {
        const parent = document.getElementById('table');
        let children = parent.getElementsByClassName('k-grid-content k-virtual-content');
        children[0].scrollTop = 0;

        const objs = [...this.state.objects];
        const data = orderBy(filterBy(objs, e.dataState.filter), e.dataState.sort);
        const filteredData = data.splice(0, 20);

        this.setState({
            dataState:       e.dataState,
            filteredObjects: data,
            gridData:        filteredData
        });

    }

    onHeaderSelectionChange = (event) => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = cloneDeep(this.state.tableSelectState);
        this.state.gridData.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
        });

        if (checked) {
            this.setProfile({
                ...this.state.profile,
                deviceIds: this.state.objects.map(item => item.id)
            });
        } else {
            this.setProfile({
                ...this.state.profile,
                deviceIds: []
            });
        }

        this.setState({
            tableSelectState: newSelectedState
        });
    };

    onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: this.state.tableSelectState,
            dataItemKey:   'id',
        });

        var deviceIds = Object.keys(newSelectedState).filter(item => {
            return newSelectedState[item];
        });

        this.setProfile({
            ...this.state.profile,
            deviceIds
        });

        this.setState({
            tableSelectState: newSelectedState
        });
    };

    pageChange = (event) => {
        this.setState({
            skip: event.page.skip
        });
    };

    scrollHandler = (event) => {
        const e = event.nativeEvent;

        if (
            e.target.scrollTop + 10 >=
            e.target.scrollHeight - e.target.clientHeight
        ) {
            const moreData = this.state.filteredObjects.splice(0, 10);

            if (moreData.length > 0) {
                let newData = [...this.state.gridData, ...moreData];
                this.setState({
                    gridData: newData
                });
            }
        }
    };

    toggleWorkbookMode = () => {
        const { filterable } = this.state;

        const objs = [...this.state.objects];
        const data = orderBy(filterBy(objs, initialDataState.filter), initialDataState.sort);
        const filteredData = data.splice(0, 20);

        this.setState({
            filterable:      !filterable,
            filteredObjects: data,
            gridData:        filteredData,
            dataState:       initialDataState,        
            filter:          initialDataState.filter
        });
    }

    setFilter = event => {
        this.setState({
            filter: event
        });
    }

    render() {
        const { companyInfo, selectedAgent, selectedDevice } = this.props;
        const {
            completedObjects,
            dataErrors,
            isSubmitting,
            objects,
            pendingActions,
            pendingObjects,
            profile,
            resultErrors,
            showPendingActionsModal
        } = this.state;

        if (!selectedDevice) return null;

        return (
            <EsmsPage
                child="Create New Profile"
                handlers={[
                    this.handleRedirectToIotHub,
                    this.handleRedirectToAgents,
                    this.handleRedirectToAgent
                ]}
                parents={[
                    companyInfo.companyName,
                    'BAS Agents',
                    selectedAgent.name,
                    'Profiles'
                ]}
                sidebar={(
                    <EditProfileForm
                        errors={dataErrors}
                        onCancel={this.handleCancel}
                        onChange={this.handleChange}
                        onSubmit={this.handleCreate}
                        profile={profile}
                    />
                )}
                title="Select Objects"
            >
                <React.Fragment>
                    <ActionBar>
                        <ActionBarItem
                            onClick={this.toggleWorkbookMode}
                            type="edit"
                        >
                            Workbook Mode
                        </ActionBarItem>
                        <ActionBarItem
                            onClick={this.handleNameDescriptionSwap}
                            type="swap"
                        >
                            Swap Name/Description
                        </ActionBarItem>
                    </ActionBar>
                    <div className={classes.tableWrapper}>
                        <style>
                            { kendoGridInlineStyling }
                        </style>
                        <div className={classes.DeviceObjectTable} id="table">
                            <Grid
                                className={classes.KendoGrid}
                                sortable
                                dataItemKey="id"
                                selectedField="selected"
                                onSelectionChange={this.onSelectionChange}
                                onHeaderSelectionChange={this.onHeaderSelectionChange}
                                total={objects.length}
                                data={this.state.gridData.map((item) => ({
                                    ...item, 'selected': this.state.tableSelectState[idGetter(item)],
                                }))}
                                onScroll={this.scrollHandler}
                                {...this.state.dataState}
                                onDataStateChange={this.dataStateChange}
                                fixedScroll={true}
                                filterable={this.state.filterable}
                            >
                                <Column
                                    filterable={false}
                                    field="selected"
                                    width="75px"
                                    headerSelectionValue={
                                        this.state.gridData.length > 0 && 
                                        this.state.gridData.findIndex((item) => !this.state.tableSelectState[idGetter(item)]) === -1
                                    }
                                />
                                <Column
                                    title="Name"
                                    field="ObjectName"
                                    cell={this.renderName}
                                    width="250px"
                                />
                                <Column
                                    title="Description"
                                    field="Description"
                                    cell={this.renderName}
                                    width="auto"
                                />
                                <Column
                                    title="Data Type"
                                    field="dataType"
                                    cell={this.renderDataTypeCell}
                                    width="auto"
                                />
                                <Column
                                    title="Trend Interval"
                                    field="sampleInterval"
                                    cell={this.renderTrendIntervalCell}
                                    width="auto"
                                    filter={'numeric'}
                                />
                                <Column
                                    title="Object Type"
                                    field="displayObjectType"
                                    width="auto"
                                    cell={this.renderObjectTypeCell}
                                />
                                <Column 
                                    field="ObjectValue" 
                                    title="Object Value" 
                                    width="auto" 
                                    filter={'numeric'}
                                />
                            </Grid>
                        </div>
                    </div>
                    <ProfileObjectModificationModal
                        completed={completedObjects}
                        modificationType="create"
                        open={isSubmitting}
                        pending={pendingObjects}
                    />
                    <ProfileObjectModificationResultModal
                        errors={resultErrors}
                        isCreate={true}
                        modificationType="create"
                        onClose={this.handleResultClose}
                        open={resultErrors.length > 0}
                    />
                    <PendingActionsModal
                        onClose={() => this.handlePendingActionsModal(false)}
                        onConfirm={this.handleSubmit}
                        open={showPendingActionsModal}
                        actionData={pendingActions}
                        title="Pending Profile Object Actions"
                    />
                </React.Fragment>
            </EsmsPage>
        );
    }
}

const mapStateToProps = ({ basAgent, ...state }) => {
    const { basAgents, selectedAgentId } = basAgent;
    const selectedAgent = basAgents[selectedAgentId];
    return {
        bacnetInventory: state.inventory.bacnetInventory,
        companyInfo:     state.companyInfo,
        currentScopes:   state.core.currentScopes,
        devices:         state.device.devices,
        profiles:        state.profile.profiles,
        selectedAgent,
        selectedDevice:  state.device.selectedDevice
    };
};

const mapDispatchToProps = {
    createBulkProfileObject,
    ...ApplicationMessageActions,
    ...CoreActions,
    ...DeviceActions,
    ...InventoryActions,
    ...ProfileActions,
    ...ProfileObjectActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BacnetProfileCreatePage));
